<template>
<div class="info_container">
    <a>Przyjmujemy zamówienia na całe mieszkania.</a>
</div>
</template>

<script>
export default {
    name: 'Info'
}
</script>

<style scoped lang="scss">
    .info_container{
        margin: 12px 0;
        background: #262626;
        color: white;
        padding: 12px 34px;
        text-align: center;
    }
    @media (min-width:1440px){
        .info_container{
            padding: 34px;
            margin: 62px 100px;
        }
    }
    @media (max-width: 640px) and (orientation: landscape){
        .info_container{
            padding: 22px;
        }
    }
</style>